import e from "react";
import { componentName as t } from "../../../utils/bem/index.js";
import { cloneAndRender as l } from "../../../utils/template/index.js";
function i(i) {
  var m = i.selected,
    n = i.item,
    o = i.className,
    s = i.template,
    a = i.onClick,
    r = i.onContextMenu,
    c = t("selectable-list-item", o, {
      selected: m,
      disabled: null == n ? void 0 : n.disabled
    });
  return e.createElement("li", {
    className: c,
    onClick: a,
    onContextMenu: r
  }, l(s, n));
}
export { i as SelectableListItem };